import { Company } from './company';
import { Location } from './location';
import { Reseller } from './reseller';
import { Employee as EmployeePanel } from './employee/Employee';

import type { Operation } from '@/types/general';
import { Selection } from '../orgNavTypes';
import type { SelectionState } from '../useOrgNavState';
import { System } from './system';
import { useOperation } from './useOperation';

type PanelProps = {
    selection: SelectionState;
    onSuccess: () => void;
};

export type ManageProps = {
    /**
     * ID must always be provided - even in create mode.
     * Prevents error possibilities +
     */
    operation: Operation;
    id?: number;
    /**
     * Perform operations in the parent component after the form is submitted successfully.
     */
    onSuccess: () => void;
};

const SELECTION_COMPONENTS = {
    [Selection.Company]: Company,
    [Selection.Reseller]: Reseller,
    [Selection.Location]: Location,
    [Selection.System]: System,
    [Selection.Employee]: EmployeePanel as any,
};

export const Panel = ({ selection, onSuccess }: PanelProps) => {
    const Component = selection.type && SELECTION_COMPONENTS[selection.type];

    const operation = useOperation();

    return Component ? <Component operation={operation} id={selection.id!} onSuccess={onSuccess} /> : null;
};
